module.exports = __webpack_public_path__ + "media/images/custom_page/limyoungmin_event/limyoungmin-event-tw-86ca1cbe75e212cea181398af084fd78.png";